import React, { Component, PropTypes } from 'react';
import { parseQueryString } from './../store/history.js';
import paymentResultView from './payment-result/payment-result-view.js';

let globalNotificationElem;
let paymentResultElem;


function openResult() {
	globalNotificationElem.classList.add('global-notification--is-open');
	paymentResultElem.classList.add('notify--is-open');
}

function removeOpenClasses() {
	globalNotificationElem.classList.remove('global-notification--is-open');
	paymentResultElem.classList.remove('notify--is-open');
}

function openDeposit(urlParams) {
	globalNotificationElem = document.getElementsByClassName('js-global-notification')[0];
	paymentResultElem = document.getElementsByClassName('js-payment-result-information-message')[0];
	openResult();
	const type = 'deposit';
	paymentResultView.init(type, urlParams);
}

class PaymentResult extends Component {
	constructor(props) {
		super(props);
		globalNotificationElem = document.getElementsByClassName('js-global-notification')[0];
		paymentResultElem = document.getElementsByClassName('js-payment-result-information-message')[0];
	}

	componentWillMount() {
		const { match: { params: { type } }, location } = this.props;
		const query = parseQueryString(location);
		openResult();
		paymentResultView.init(type, query);
	}

	componentWillUnmount() {
		removeOpenClasses();
	}

	openDeposit() {
		openDeposit();
	}

	render() {
		return (
			<div id="payment-result" />
		);
	}
}

PaymentResult.propTypes = {
	params: PropTypes.object,
	location: PropTypes.object,
	match: PropTypes.object
};

PaymentResult.functions = {
	open: openDeposit
};


export default PaymentResult;




// WEBPACK FOOTER //
// ./mobile-core/src/components/payment-result.js